export enum CdnProvider {
  CLOUDFLARE = 'cloudflare',
  AKAMAI = 'akamai',
  FASTLY = 'fastly',
  MAXCDN = 'maxcdn',
  CLOUDFRONT = 'cloudfront',
  CHINACACHE = 'chinacache',
  BITGRAVITY = 'bitgravity',
}
